const urlParser = document.createElement('a')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function prettyDate (date) {
  var a = new Date(date)
  return a.toDateString()
}

export function dateFormatter (date) {
  const d = new Date(date)
  return `${('0' + d.getDate()).slice(-2)}/${('0' + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`
}

export function dateFormatterLastActivity(date) {
  const d = new Date(date);
  const formattedDate = `${('0' + d.getDate()).slice(-2)}/${('0' + (d.getMonth() + 1)).slice(-2)}/${d.getFullYear()}`;
  const formattedTime = `${('0' + d.getHours()).slice(-2)}h${('0' + d.getMinutes()).slice(-2)}`;

  return `${formattedDate} ${formattedTime}`;
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}



// WEBPACK FOOTER //
// ./src/filters/index.js